module.exports = __webpack_public_path__ + "img/negative_thinking_trigger.97e6da8f.jpg";